import styled from "styled-components";
export const Hr = styled.hr.withConfig({
  displayName: "Hr",
  componentId: "sc-dq6tnu-0"
})(["margin:0;border:none;", " border-bottom:", "px solid;border-bottom-color:", ";"], props => props.fullWidth && "width: 100%;", props => props.size, props => props.borderBottomColor);
export default Hr;